import { render, staticRenderFns } from "./_orders.component.vue?vue&type=template&id=6c412baa&scoped=true"
import script from "./_orders.component.vue?vue&type=script&lang=js"
export * from "./_orders.component.vue?vue&type=script&lang=js"
import style0 from "./_orders.component.vue?vue&type=style&index=0&id=6c412baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c412baa",
  null
  
)

export default component.exports